import { CommonModule } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { images } from '../../_shared/data/image';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-login-signup-home',
  templateUrl: './login-signup-home.component.html',
  styleUrls: ['./login-signup-home.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, RouterModule, TranslateModule],
})
export class LoginSignupHomeComponent implements OnInit {
  @Output() authAction = new EventEmitter<string>();
  @Input({ required: false }) isLoginModal = false;
  public ioncourtLogo = images.ioncourt;

  constructor(
    private modalController: ModalController,
  ) {}

  async ngOnInit() {
 }

  onAuthAction(action: 'signup' | 'signin') {
    this.authAction.emit(action);
  }

  close() {
    this.modalController.dismiss();
  }

}
